import http from '../shared/HttpCommon';
import { CommunityManagement } from '../shared/interfaces/ICommunityManagement';

const startScraping = async (
  platform: string,
  company: string,
  label: string,
  url: string,
  isBenchmark: boolean,
  communityManagement: CommunityManagement | null
) => {
  try {
    const { data } = await http.post(`/${platform.toLowerCase()}/scrape`, {
      company,
      label,
      url,
      isBenchmark,
      communityManagement,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

const ScrapeService = {
  startScraping,
};

export default ScrapeService;
